import { User } from './user'
import { Decodable } from './_decodable'
import { ProductCategory } from './product-category'
import { Unit } from './unit'
import { toAmount } from 'app/helpers/money'

const toAmountOrNull = (value: any) => value === null || value === undefined || value === '' ? value : toAmount(value)

class Product extends Decodable {

    id?: number
    productCategoryId?: number
    unitId?: number
    code?: string
    title?: string
    image?: string
    description?: string
    type?: string
    valor?: number
    stockQuantity?: number
    stockControlEnabled?: boolean
    estoqueMinimo?: number
    valorCompra?: number
    status?: number

    // Campo adicional retornado pelo autocomplete para facilitar snapshot
    productCategoryName?: string

    productCategory?: ProductCategory
    unit?: Unit
    createdAt?: Date
    updatedAt?: Date

    // Decimais chegam como texto ("2.90"): número para os campos de moeda
    protected _map = {
        valor: e => toAmountOrNull(e),
        valorCompra: e => toAmountOrNull(e),
        productCategory: e => ProductCategory.parse(e),
        unit: e => Unit.parse(e),
        createdAt: e => this.parseDate(e),
        updatedAt: e => this.parseDate(e),
    }
}

export {
    Product
}
